import React, { useEffect } from 'react';
import { Outlet, useNavigate } from "react-router-dom";
import { useStore } from './store';
import { Header, Footer, LoadingOverlay } from './Components/elements';
import 'react-datasheet-grid/dist/style.css';
import './App.css';

function App() {
  const navigate = useNavigate();
  // Get state from the store as defined in your original file
  const { isAuthed, isSubmitting, } = useStore();

  // This effect handles redirecting unauthenticated users
  useEffect(() => {
    if (!isAuthed) {
      navigate("/auth");
    }
  }, [isAuthed, navigate]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {isSubmitting && <LoadingOverlay />}

      {isAuthed && <Header />}

      <main className="flex-grow container mx-auto p-4 pb-20">
        <Outlet />
      </main>

      {isAuthed && <Footer />}
    </div>
  );
}

export default App;
